export var SliderVariantType;
(function (SliderVariantType) {
    /**
     * @deprecated
     * This variant is deprecated. Will be removed in the next major version.
     * Use RANGE or PROGRESSIVE variant instead.
     */
    SliderVariantType["DEFAULT"] = "DEFAULT";
    SliderVariantType["RANGE"] = "RANGE";
    SliderVariantType["PROGRESSIVE"] = "PROGRESSIVE";
})(SliderVariantType || (SliderVariantType = {}));
//# sourceMappingURL=variants.js.map